import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToolsService } from '../../tools/tools.service';
import {SalemethodService} from "../../api/salemethod/salemethod.service";

@Injectable({
  providedIn: 'root'
})

export class ClientProductsFavoriteService {

  constructor(
    private baseClient: BaseclientService,
    private tools: ToolsService
  ) { }

  getProductsFavorite(): Observable<any> {
    let currSm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
    let currPOS: any = this.tools.getStor("point_of_sale");
    const params = {
      id_point_of_sale: currPOS.id,
      id_sale_method: currSm.id,
    }
    return from(this.baseClient.postBase("products_favorite_client", params)).pipe(
      map(data => data)
    )


  }





}
